import tokens from "./tokens.json";

import { DefaultTheme } from "styled-components";
const { colors, customStyles, fonts, images, radius, shadows } = tokens;
export const theme: DefaultTheme = {
    fontFamily: "Open Sans",
    fontWeights: {
        normal: 400,
        bold: 500,
    },
    defaultFontSize: 14,
    contentMaxWidth: 1280,
    sideMenuWidth: 260,
    headerHeight: 50,
    OnBehalfOfHeaderHeight: 38,
    OnBehalfOfHeaderCollapsedHeight: 24,
    footerHeight: 80,
    gutter: 8,
    tokens: {
        colors,
        customStyles,
        radius,
        images,
        fonts,
        shadows,
    },
};
